// eslint-disable-next-line no-shadow
export enum EventTypes {
  BACK = 0,
  NEXT = 1,
  SKIP = 2,
  HOME = 3,
  BUSINESS_PROFILE = 4,
  FINANCIAL_PROFILE = 5,
  CUSTOMER_PORTFOLIO = 6,
  DOCUMENTS = 7,
  CHANGE_EMAIL = 8,
  CHANGE_MOBILE = 9,
  CONFIRM_EMAIL = 10,
  CONFIRM_MOBILE = 11,
  RESEND = 12,
  BP_SUMMARY_EDIT = 13,
  AUTOFILL = 14,
  MANUAL = 15,
  YES = 16,
  NO = 17,
  APPLICATION_SUMMARY = 18,
  SIGN_UP = 19,
  OTHER = 20,
  REFERRAL = 21,
  BP_EDIT1 = 22,
  BP_EDIT2 = 23,
  BP_EDIT3 = 24,
  BP_EDIT4 = 25,
  BP_EDIT5 = 26,
  BP_EDIT6 = 27,
  BP_EDIT7 = 28,
  BP_EDIT8 = 29,
  BP_EDIT9 = 30,
  BP_EDIT10 = 31,
  BP_EDIT11 = 32,
  BP_EDIT12 = 33,
  BP_EDIT13 = 42,

  BELOW_SBFE_THRESHOLD = 34,
  COMPANY_NOT_FOUND = 35,
  COMPANY_NOT_QUALIFIED = 36,
  SOLE_PROPRIETORSHIP = 37,
  NO_SCORE = 38,
  INDUSTRY_SOURCE_NOT_QUALIFIED = 39,
  CONTACT_SUPPORT = 40,
  PRE_QUALIFIED = 41,

  MONTHLY_ABOVE_THRESHOLD = 60,
  MONTHLY_BELOW_THRESHOLD = 61,
  TERM_BELOW_THRESHOLD = 62,
  TERM_ABOVE_THRESHOLD = 63,
  IS_PO_BOX = 64,
  IS_NOT_PO_BOX = 65,

  ADD_ANOTHER_CUSTOMER = 66,
  RESCORE = 67,
  FINISH_CUSTOMER_PORTFOLIO = 68,
  ADDITIONAL_CREDIT_INFO = 69,
  ATRADIUS_TIMED_OUT = 70,
  CUSTOMER_GRID = 71,
  CUSTOMER_GRID_HOME = 72,
}
